import { apiFetch } from "./apiClient";

export async function getLatestDeviceOperations(filters = {}) {
  const params = new URLSearchParams();

  if (filters.devicePkId != null) {
    params.append("devicePkId", String(filters.devicePkId));
  }

  if (filters.customerId != null) {
    params.append("customerId", String(filters.customerId));
  }

  if (filters.locationPkId != null) {
    params.append("locationPkId", String(filters.locationPkId));
  }

  if (filters.buildingPkId != null) {
    params.append("buildingPkId", String(filters.buildingPkId));
  }

  if (filters.departmentPkId != null) {
    params.append("departmentPkId", String(filters.departmentPkId));
  }

  if (filters.roomPkId != null) {
    params.append("roomPkId", String(filters.roomPkId));
  }

  if (filters.roomTypeName) {
    params.append("roomTypeName", String(filters.roomTypeName));
  }

  if (filters.state) {
    params.append("state", String(filters.state));
  }

  if (typeof filters.problematicOnly === "boolean") {
    params.append("problematicOnly", String(filters.problematicOnly));
  }

  if (filters.startDate) {
    params.append("startDate", String(filters.startDate));
  }

  if (filters.endDate) {
    params.append("endDate", String(filters.endDate));
  }

  if (filters.limit != null) {
    params.append("limit", String(filters.limit));
  }

  if (filters.offset != null) {
    params.append("offset", String(filters.offset));
  }

  const query = params.toString();
  const url = query
    ? `/api/services/device-operations/latest?${query}`
    : "/api/services/device-operations/latest";

  const response = await apiFetch(url);

  if (!response?.ok) {
    throw new Error("Failed to fetch latest device operations");
  }

  const payload = await response.json();
  return Array.isArray(payload?.rows) ? payload.rows : [];
}

export async function getDeviceOperationsHistory(devicePkId, filters = {}) {
  const params = new URLSearchParams();

  if (filters.state) {
    params.append("state", String(filters.state));
  }

  if (filters.startDate) {
    params.append("startDate", String(filters.startDate));
  }

  if (filters.endDate) {
    params.append("endDate", String(filters.endDate));
  }

  if (filters.limit != null) {
    params.append("limit", String(filters.limit));
  }

  const query = params.toString();
  const url = query
    ? `/api/services/device-operations/history/${devicePkId}?${query}`
    : `/api/services/device-operations/history/${devicePkId}`;

  const response = await apiFetch(url);

  if (!response?.ok) {
    throw new Error("Failed to fetch device operations history");
  }

  const payload = await response.json();
  return Array.isArray(payload?.rows) ? payload.rows : [];
}

export async function getDeviceSchedules(devicePkId) {
  const response = await apiFetch(
    `/api/services/device-operations/${devicePkId}/schedules`,
  );

  if (!response?.ok) {
    throw new Error("Failed to fetch device schedules");
  }

  const payload = await response.json();
  return Array.isArray(payload?.rows) ? payload.rows : [];
}

export async function assignDeviceOperation(operationPkId, assignedUserId) {
  const response = await apiFetch(
    `/api/services/device-operations/${operationPkId}/assign`,
    {
      method: "POST",
      body: JSON.stringify({ assigned_user_id: assignedUserId }),
    },
  );

  const payload = await response.json().catch(() => ({}));

  if (!response?.ok) {
    throw new Error(payload?.error || "Failed to assign device operation");
  }

  return payload?.result || null;
}

export async function notifyRcTekniker(operationPkId, payload = {}) {
  const response = await apiFetch(
    `/api/services/device-operations/${operationPkId}/notify-rc-tekniker`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );

  const body = await response.json().catch(() => ({}));

  if (!response?.ok) {
    throw new Error(body?.error || "Failed to notify RC Tekniker");
  }

  return body;
}
